
// import React, { useEffect, useState } from "react";
// import { Menu, MenuItem, IconButton, Checkbox, ListItemText, Divider } from '@mui/material';
// import EditIcon from '@mui/icons-material/Edit'; // Import the Edit icon
// import dayjs from "dayjs";
// import ForwardIcon from '@mui/icons-material/Forward';
// import './CommonDynamicTable.css';
// import AddIcon from '@mui/icons-material/Add';
// import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
// import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
// import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
// import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';

// const CommonDynamicTable = ({ data, dataType,
//   showEditButton, Originaldata, handleHeaderClick,
//   filteredData, selectedFilters,
//   onEditRow, onShow, handleOpportunityClick, setMenuColumn, menuColumn, accessLevel, selectedValues, handleMenuItemClick, handleSortClick, sortConfig }) => {
//   const [anchorEl, setAnchorEl] = useState(null);
//   const [menuItems, setMenuItems] = useState([]);
//   const [dateRange, setDateRange] = useState({ from: null, to: null });
//   const [tableHeaders, setTableHeaders] = useState([]);
//   useEffect(() => {
//     const sourceData = Originaldata && Originaldata.length > 0 ? Originaldata : data;
//     if (sourceData.length > 0) {
//       setTableHeaders(Object.keys(sourceData[0]));
//     }
//   }, [data, Originaldata]);
//   const handleMenuOpen = (event, columnName) => {
//     event.stopPropagation();
//     if (columnName !== menuColumn) {
//       setDateRange({ from: null, to: null });
//     }
//     setAnchorEl(event.currentTarget);
//     setMenuColumn(columnName);
//     const isDateColumn = ['Oppr_Create_Date', 'Due_Date', 'Order_Date'].includes(columnName);
//     if (isDateColumn) {
//       setMenuItems([]); // No checkbox items for date filters
//     } else {
//       data = Originaldata || [];
//       let uniqueValues = [];
//       if (columnName === 'Next_FollowUp' || columnName === 'Last_FollowUp') {
//         uniqueValues = [
//           ...new Set(
//             data
//               .map(item => item[columnName]?.split(' - ')[1]?.trim())
//               .filter(Boolean)
//           )
//         ];
//       } else {
//         uniqueValues = [
//           ...new Set(
//             data
//               .map(item => item[columnName]?.toString().trim())
//               .filter(Boolean)
//           )
//         ];
//       };
//       setMenuItems(uniqueValues);
//     }
//   }

//   const handleMenuClose = () => {
//     setAnchorEl(null);
//   };
//   // const getValueCount = (value) => {
//   //   const filters = Originaldata.length > 0 && Originaldata;
//   //   return filters.filter((item) => {
//   //     const colValue = item[menuColumn];
//   //     // if (menuColumn === 'Due_Days') {
//   //     //   const due = parseInt(item['Due_Days'], 10);
//   //     //   if (value === '0-20') return due >= 0 && due <= 20;
//   //     //   if (value === '21-40') return due >= 21 && due <= 40;
//   //     //   if (value === '41-60') return due >= 41 && due <= 60;
//   //     //   if (value === '60+') return due > 60;
//   //     //   return false;
//   //     // }

//   //     if (!colValue) return false;
//   //     if (menuColumn === 'Next_FollowUp' || menuColumn === 'Last_FollowUp') {
//   //       const secondPart = colValue.split(' - ')[1];
//   //       return secondPart === value;
//   //     }

//   //     if (menuColumn === 'Due_Date' || menuColumn === 'Order_Date') {
//   //       return dayjs(colValue).format('DD/MM/YYYY') === value;
//   //     }
//   //     return colValue === value;
//   //   }).length;
//   // };
//   const getValueCount = (value) => {
//     // For 'SlpName' column, always use Originaldata
//     const dataToUse = menuColumn === 'SlpName' ? Originaldata : (filteredData.length > 0 ? filteredData : Originaldata);
//     // const dataToUse = filteredData.length > 0 ? filteredData : Originaldata;
//     if (dataToUse && dataToUse.length > 0) {
//       return dataToUse.filter((item) => {
//         const colValue = item[menuColumn];
  
//         // Handle 'Next_FollowUp' or 'Last_FollowUp' (assuming split format 'SomeString - Date')
//         if (menuColumn === 'Next_FollowUp' || menuColumn === 'Last_FollowUp') {
//           const secondPart = colValue.split(' - ')[1];  // Extract date part
//           return secondPart === value;
//         }
  
//         // Handle date columns (e.g., 'Due_Date', 'Order_Date')
//         if (menuColumn === 'Due_Date' || menuColumn === 'Order_Date') {
//           return dayjs(colValue).format('DD/MM/YYYY') === value;
//         }
  
//         // For all other columns, perform a direct comparison
//         return colValue === value;
//       }).length;
//     }
  
//     return 0;  // Return 0 if no matching data is found
//   };
  
//   return (
//     <table className=" table-design">
//       <thead className="table-header">
//         <tr>
//           {/* {showEditButton && <th style={{ padding: '8px' }}></th>} */}

//           {tableHeaders.map((col, index) => {
//             if (dataType === "customerFollowups" && accessLevel === "L2" && col === "SlpName") {
//               return null;  // Don't render this column
//             }
//             if (dataType === "customerFollowups" && col === "DocEntry") return null;
//             if (dataType === "sqItemhistory" && col === "Document_Total") return null;
//             if (dataType === "customerFollowups" && col === "SlpCode") return null;
//             if (dataType === "OppStage" && col === "id") return null;
//             if (dataType === "OppStage" && col === "status") return null;
//             if (dataType === "OppStage" && col === "stageId") return null;
//             if (dataType === "sqhistory" && col === "DocEntry") return null;
//             if (dataType === "sqItemhistory" && col === "DocEntry") return null;
//             const displayName = col.replace(/_/g, ' ').replace(/\b\w/g, char => char.toUpperCase());
//             return (
//               <th key={index} className="tableBorder"
//                 style={{
//                   padding: '8px',
//                   backgroundColor: (dataType === 'customerFollowups' || dataType === 'sqhistory') && selectedFilters[col]?.length > 0 ? 'Grey' : '',
//                   position: 'relative'
//                 }}
//                 onClick={(e) => {
//                   // Avoid header click when the target is the sort icon button
//                   if (
//                     (dataType === "customerFollowups" || dataType === "sqhistory") &&
//                     col !== "SI_No" &&
//                     !e.target.closest('.sort-icon-btn')
//                   ) {
//                     handleHeaderClick(col);
//                   }
//                 }}>
//                 {displayName}

//                 {/*sort functionality for 'Opp_No' and 'Due_Days'  */}
//                 {['Opp_No', 'Due_Days'].includes(col) && (
//                   <IconButton
//                     className="sort-icon-btn"
//                     onClick={(e) => {
//                       e.stopPropagation();  // Prevent th's onClick
//                       handleSortClick(col);
//                     }}
//                     style={{
//                       position: 'absolute',
//                       right: '0px',
//                       top: '50%',
//                       transform: 'translateY(-50%)',
//                       color: 'white',
//                       zIndex: 10,
//                     }}
//                   >
//                     {sortConfig?.column === col && sortConfig?.direction === 'asc' ? (
//                       <ArrowUpwardIcon sx={{ fontSize: '14px' }} />
//                     ) : (
//                       <ArrowDownwardIcon sx={{ fontSize: '14px' }} />
//                     )}
//                   </IconButton>
//                 )}

//                 {(dataType === 'customerFollowups' || dataType === "sqhistory") && (
//                   <>
//                     {['SlpName', 'Oppr_Create_Date', 'Status', 'AR_Status', 'Lost_Request', 'Next_FollowUp', 'Last_FollowUp', 'DocStatus', 'Due_Date', 'Order_Date'].includes(col) && (
//                       <IconButton
//                         onClick={(e) => handleMenuOpen(e, col)}
//                         style={{
//                           position: 'absolute',
//                           right: '3px',
//                           top: '50%',
//                           transform: 'translateY(-50%)',
//                           color: 'white',
//                           zIndex: 10,
//                         }}
//                       >

//                         <ArrowDropDownIcon />
//                       </IconButton>
//                     )}
//                   </>
//                 )}
//               </th>
//             );
//           })}
//           {(dataType === "OppStage" || dataType === "sqhistory") && <th style={{ padding: '8px' }}>Action</th>}
//         </tr>
//       </thead>
//       <tbody className="table-body">
//         {data.length === 0 ? (
//           <tr>
//             <td colSpan={tableHeaders.length + 1} style={{ textAlign: 'center', padding: '12px', fontStyle: 'italic' }}>
//               No data found
//             </td>
//           </tr>
//         ) : (

//           data.map((item, rowIndex) => (
//             <tr key={rowIndex} onClick={() => {
//               if (dataType !== "sqItemhistory") {
//                 onEditRow(item);
//               }
//             }}>
//               {Object.entries(item).map(([key, cell], cellIndex) => {
//                 // Skip rendering the cell if the condition is met
//                 if (dataType === "customerFollowups" && accessLevel === "L2" && key === "SlpName") {
//                   return null;  // Don't render this column
//                 }
//                 if (dataType === "sqItemhistory" && key === "DocEntry") return null;
//                 if (dataType === "sqItemhistory" && key === "Document_Total") return null;
//                 if (dataType === "sqhistory" && key === "DocEntry") return null;
//                 if (dataType === "customerFollowups" && key === "DocEntry") return null;
//                 if (dataType === "customerFollowups" && key === "SlpCode") return null;
//                 if (dataType === "OppStage" && key === "id") return null;
//                 if (dataType === "OppStage" && key === "status") return null;
//                 if (dataType === "OppStage" && key === "stageId") {
//                   return null; // Skip rendering this column
//                 }
//                 if (dataType === "sqhistory" && key === "Opportunity_No") {
//                   return (
//                     <td className="table-bodyBorder  opportunity-column" key={cellIndex}  >

//                       {cell ? (
//                         <button
//                           className="OppGoldBtn"
//                           onClick={(e) => {
//                             e.stopPropagation(); // Prevent triggering the row's onClick
//                             handleOpportunityClick(cell);
//                           }}
//                         >
//                           <ForwardIcon style={{ marginRight: '4px', color: 'gold', fontSize: '16px' }} />
//                           {cell}
//                         </button>
//                       ) : (
//                         <span>{cell}</span> // Optional: replace with an empty string or any fallback text
//                       )}
//                     </td>
//                   );
//                 }
//                 if (dataType === "customerFollowups" && key === "Sales_Quotation") {
//                   return (
//                     <td className="table-bodyBorder opportunity-column" key={cellIndex} >
//                       {cell && typeof cell !== 'object' ? (
//                         <button
//                           className="OppGoldBtn"
//                           onClick={(e) => {
//                             e.stopPropagation(); // Prevent triggering the row's onClick
//                             onShow(item);
//                           }}
//                         >
//                           <ForwardIcon style={{ marginRight: '4px', color: 'gold', fontSize: '16px' }} />
//                           {cell}
//                         </button>
//                       ) : (
//                         <button
//                           className="btn_Sq"
//                           onClick={(e) => {
//                             e.stopPropagation();
//                             handleOpportunityClick(item);
//                           }}
//                         >
//                           <AddCircleOutlineIcon style={{ marginRight: '4px' }} className="addIcon" /> Add SQ
//                         </button>
//                       )}
//                     </td>
//                   );
//                 }

//                 // const formattedCell = (typeof cell === 'string' && cell.includes('T'))
//                 //   ? dayjs(cell).format('DD/MM/YYYY')
//                 //   : cell;

//                 const formattedCell = (typeof cell === 'string' && cell.includes('T'))
//                   ? dayjs(cell).format('DD/MM/YYYY')
//                   : (typeof cell === 'object' && cell !== null)
//                     ? JSON.stringify(cell)  // Convert object to string or handle it differently
//                     : cell;
//                 return (
//                   <td className="table-bodyBorder" key={cellIndex} style={{ padding: '8px' }}>
//                     {cell}
//                   </td>
//                 );
//                 // return (
//                 //   <td className="table-bodyBorder" key={cellIndex} style={{ padding: '8px' }}>
//                 //     {cell}
//                 //   </td>
//                 // );
//               })}
//               {dataType === "OppStage" && item.status === "O" && (
//                 <td className="table-bodyBorder" style={{ padding: '8px' }}>
//                   <IconButton onClick={(e) => { e.stopPropagation(); onEditRow(item.id); }}>
//                     <EditIcon />
//                   </IconButton>
//                 </td>
//               )
//               }

//               {
//                 dataType === "sqhistory" && (
//                   <td className="table-bodyBorder" style={{ padding: '4px' }}>
//                     {/* Add your action for sqhistory here */}
//                     <IconButton onClick={(e) => { e.stopPropagation(); showEditButton(item); }}>
//                       <EditIcon />
//                     </IconButton>
//                   </td>
//                 )
//               }
//             </tr>
//           ))
//         )}
//       </tbody>
//       {dataType === "sqItemhistory" &&
//         <tfoot>
//           <tr>
//             <td colSpan="7" style={{ textAlign: 'right', fontWeight: 'bold' }}>Document Total:</td>
//             <td>{data.length > 0 ? data[data.length - 1].Document_Total : ''}</td>
//           </tr>
//         </tfoot>
//       }
//       <Menu
//         className='menu_div'
//         anchorEl={anchorEl}
//         open={Boolean(anchorEl)}
//         onClose={handleMenuClose}
//       >
//         {/* Date range filtering UI */}
//         {['Oppr_Create_Date', 'Due_Date', 'Order_Date'].includes(menuColumn) ? (
//           <div style={{ padding: '20px', width: '230px' }}>
//             <label>From Date</label>
//             <input
//               type="date"
//               value={dateRange.from || ''}
//               onChange={(e) =>
//                 setDateRange(prev => ({ ...prev, from: e.target.value }))
//               }
//             />
//             <label style={{ marginTop: '10px' }}>To Date</label>
//             <input
//               type="date"
//               value={dateRange.to || ''}
//               onChange={(e) =>
//                 setDateRange(prev => ({ ...prev, to: e.target.value }))
//               }
//             />
//             <button
//               className="frmtodate"
//               style={{ marginTop: '12px' }}
//               onClick={() => {
//                 if (!dateRange.from || !dateRange.to) {
//                   alert('Please select both From and To dates.');
//                   return;
//                 }
//                 handleMenuItemClick(dateRange);
//                 handleMenuClose();
//               }}
//             >
//               Apply
//             </button>
//           </div>
//         ) : (
//           <div>
//             {/* ✅ Sorting Options for Next_FollowUp */}
//             {menuColumn === 'Next_FollowUp' && (
//               <>
//                 <MenuItem disabled>
//                   <ListItemText
//                     primary="Sort By Date"
//                     primaryTypographyProps={{
//                       fontWeight: 'bold',
//                       fontSize: '13px',
//                       color: '#666',
//                     }}
//                   />
//                 </MenuItem>

//                 <MenuItem
//                   selected={sortConfig?.column === 'Next_FollowUp' && sortConfig?.direction === 'asc'}
//                   onClick={() => {
//                     handleSortClick('Next_FollowUp', 'asc');
//                     handleMenuClose();
//                   }}
//                 >
//                   <ArrowUpwardIcon
//                     sx={{ fontSize: '16px', marginRight: '8px', color: '#1976d2' }}
//                   />
//                   <ListItemText primary="Asc" />
//                 </MenuItem>

//                 <MenuItem
//                   selected={sortConfig?.column === 'Next_FollowUp' && sortConfig?.direction === 'desc'}
//                   onClick={() => {
//                     handleSortClick('Next_FollowUp', 'desc');
//                     handleMenuClose();
//                   }}
//                 >
//                   <ArrowDownwardIcon
//                     sx={{ fontSize: '16px', marginRight: '8px', color: '#1976d2' }}
//                   />
//                   <ListItemText primary="Desc" />
//                 </MenuItem>

//                 <Divider />
//               </>
//             )}
//             {/* ✅ Checkbox Filters (Same as before) */}
//             {menuItems.map((item, index) => (
//               <MenuItem key={index} onClick={() => {
//                 handleMenuItemClick(item);
//                 handleMenuClose();
//               }}>
//                 <Checkbox checked={selectedFilters[menuColumn]?.includes(item) || false} />
//                 <ListItemText primary={`${item} (${getValueCount(item)})`} />
//               </MenuItem>
//             ))}
//           </div>
//         )}
//       </Menu>

//     </table>
//   );
// };

// export default CommonDynamicTable;

import React, { useEffect, useState } from "react";
import { Menu, MenuItem, IconButton, Checkbox, ListItemText, Divider } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import dayjs from "dayjs";
import ForwardIcon from '@mui/icons-material/Forward';
import './CommonDynamicTable.css';
import AddIcon from '@mui/icons-material/Add';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';

const CommonDynamicTable = ({
  data,
  dataType,
  showEditButton,
  Originaldata,
  handleHeaderClick,
  filteredData,
  selectedFilters,
  onEditRow,
  onShow,
  handleOpportunityClick,
  setMenuColumn,
  menuColumn,
  accessLevel,
  selectedValues,
  handleMenuItemClick,
  handleSortClick,
  sortConfig,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [menuItems, setMenuItems] = useState([]);
  const [dateRange, setDateRange] = useState({ from: null, to: null });
  const [tableHeaders, setTableHeaders] = useState([]);

  useEffect(() => {
    const sourceData = Originaldata && Originaldata.length > 0 ? Originaldata : data;
    if (sourceData.length > 0) {
      setTableHeaders(Object.keys(sourceData[0]));
    }
  }, [data, Originaldata]);

  const getMenuItems = (dataToUse, columnName) => {
    if (columnName === 'Next_FollowUp' || columnName === 'Last_FollowUp') {
      return [...new Set(dataToUse.map(item => item[columnName]?.split(' - ')[1]?.trim()).filter(Boolean))];
    }
    return [...new Set(dataToUse.map(item => item[columnName]?.toString().trim()).filter(Boolean))];
  };

  const handleMenuOpen = (event, columnName) => {
    event.stopPropagation();
    if (columnName !== menuColumn) {
      setDateRange({ from: null, to: null });
    }
    setAnchorEl(event.currentTarget);
    setMenuColumn(columnName);

    const isDateColumn = ['Oppr_Create_Date', 'Due_Date', 'Order_Date'].includes(columnName);
    if (isDateColumn) {
      setMenuItems([]);
    } else {
      const dataToUse = filteredData.length > 0 ? filteredData : Originaldata;
      setMenuItems(getMenuItems(dataToUse, columnName));
    }
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const getValueCount = (value) => {
    // const dataToUse = menuColumn === 'SlpName' ? Originaldata : (filteredData.length > 0 ? filteredData : Originaldata);
    const dataToUse =  filteredData.length > 0 ? filteredData : Originaldata;
    if (dataToUse && dataToUse.length > 0) {
      return dataToUse.filter((item) => {
        const colValue = item[menuColumn];
        if (menuColumn === 'Next_FollowUp' || menuColumn === 'Last_FollowUp') {
          const secondPart = colValue?.split(' - ')[1];
          return secondPart === value;
        }
        if (menuColumn === 'Due_Date' || menuColumn === 'Order_Date') {
          return dayjs(colValue).format('DD/MM/YYYY') === value;
        }
        return colValue === value;
      }).length;
    }
    return 0;
  };

  return (
    <table className="table-design">
      <thead className="table-header">
        <tr>
          {tableHeaders.map((col, index) => {
            if (
              (dataType === "customerFollowups" && accessLevel === "L2" && col === "SlpName") ||
              (dataType === "customerFollowups" && col === "DocEntry") ||
              (dataType === "sqItemhistory" && ["PriceList","Document_Total"].includes(col))||
              (dataType === "customerFollowups" && col === "SlpCode") ||
              (dataType === "OppStage" && ["id", "status", "stageId"].includes(col)) ||
              (dataType === "sqhistory" && col === "DocEntry") ||
              (dataType === "sqItemhistory" && col === "DocEntry") ||
              (dataType === "LedgerDoc" && col === "Document_Total")  
            ) {
              return null;
            }
            const displayName = col.replace(/_/g, ' ').replace(/\b\w/g, char => char.toUpperCase());
            return (
              <th key={index} className="tableBorder" style={{
                padding: '8px',
                backgroundColor: (dataType === 'customerFollowups' || dataType === 'sqhistory') && selectedFilters[col]?.length > 0 ? 'Grey' : '',
                position: 'relative'
              }}
                onClick={(e) => {
                  if (
                    (dataType === 'customerFollowups' || dataType === 'sqhistory') &&
                    col !== "SI_No" &&
                    !e.target.closest('.sort-icon-btn')
                  ) {
                    handleHeaderClick(col);
                  }
                }}>
                {displayName}
                {['Opp_No', 'Due_Days'].includes(col) && (
                  <IconButton
                    className="sort-icon-btn"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleSortClick(col);
                    }}
                    style={{
                      position: 'absolute',
                      right: '0px',
                      top: '50%',
                      transform: 'translateY(-50%)',
                      color: 'white',
                      zIndex: 10,
                    }}
                  >
                    {sortConfig?.column === col && sortConfig?.direction === 'asc' ? (
                      <ArrowUpwardIcon sx={{ fontSize: '14px' }} />
                    ) : (
                      <ArrowDownwardIcon sx={{ fontSize: '14px' }} />
                    )}
                  </IconButton>
                )}
                {(dataType === 'customerFollowups' || dataType === "sqhistory") &&
                  ['SlpName', 'Oppr_Create_Date', 'Status', 'AR_Status', 'Lost_Request', 'Next_FollowUp', 'Last_FollowUp', 'DocStatus', 'Due_Date', 'Order_Date'].includes(col) && (
                    <IconButton
                      onClick={(e) => handleMenuOpen(e, col)}
                      style={{
                        position: 'absolute',
                        right: '3px',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        color: 'white',
                        zIndex: 10,
                      }}
                    >
                      <ArrowDropDownIcon />
                    </IconButton>
                  )}
              </th>
            );
          })}
          {(dataType === "OppStage" || dataType === "sqhistory") && <th style={{ padding: '8px' }}>Action</th>}
        </tr>
      </thead>
      <tbody className="table-body">
        {data.length === 0 ? (
          <tr>
            <td colSpan={tableHeaders.length + 1} style={{ textAlign: 'center', padding: '12px', fontStyle: 'italic' }}>
              No data found
            </td>
          </tr>
        ) : (
          data.map((item, rowIndex) => (
            <tr key={rowIndex} onClick={() => {
             
              // if (dataType !== "sqItemhistory"  ) {
              //   onEditRow(item);
              // }
              if (dataType !== "sqItemhistory" && dataType !== "LedgerDoc") {
                onEditRow(item);
              }
            }}
            >
              {Object.entries(item).map(([key, cell], cellIndex) => {
                if (
                  (dataType === "customerFollowups" && accessLevel === "L2" && key === "SlpName") ||
                  (dataType === "sqItemhistory" && ["DocEntry", "Document_Total","PriceList"].includes(key)) ||
                  (dataType === "sqhistory" && key === "DocEntry") ||
                  (dataType === "customerFollowups" && ["DocEntry", "SlpCode"].includes(key)) ||
                  (dataType === "OppStage" && ["id", "status", "stageId"].includes(key)) ||
                  (dataType === "LedgerDoc" && key === "Document_Total") 
                ) {
                  return null;
                }
                if (dataType === "sqhistory" && key === "Opportunity_No") {
                  return (
                    <td className="table-bodyBorder opportunity-column" key={cellIndex}>
                      {cell ? (
                        <button
                          className="OppGoldBtn"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleOpportunityClick(cell);
                          }}
                        >
                          <ForwardIcon style={{ marginRight: '4px', color: 'gold', fontSize: '16px' }} />
                          {cell}
                        </button>
                      ) : (
                        <span>{cell}</span>
                      )}
                    </td>
                  );
                }
                if (dataType === "customerFollowups" && key === "Sales_Quotation") {
                  return (
                    <td className="table-bodyBorder opportunity-column" key={cellIndex}>
                      {cell && typeof cell !== 'object' ? (
                        <button
                          className="OppGoldBtn"
                          onClick={(e) => {
                            e.stopPropagation();
                            onShow(item);
                          }}
                        >
                          <ForwardIcon style={{ marginRight: '4px', color: 'gold', fontSize: '16px' }} />
                          {cell}
                        </button>
                      ) : (
                        <button
                          className="btn_Sq"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleOpportunityClick(item);
                          }}
                        >
                          <AddCircleOutlineIcon style={{ marginRight: '4px' }} className="addIcon" /> Add SQ
                        </button>
                      )}
                    </td>
                  );
                }
                const formattedCell = (typeof cell === 'string' && cell.includes('T'))
                  ? dayjs(cell).format('DD/MM/YYYY')
                  : (typeof cell === 'object' && cell !== null)
                    ? JSON.stringify(cell)
                    : cell;
                return (
                  <td className="table-bodyBorder" key={cellIndex} style={{ padding: '8px',textAlign:'center' }}>
                    {/* {cell} */}
                    {cell == null || cell === "" || cell === undefined ? "-" : cell}
                  </td>
                );
              })}
              {dataType === "OppStage" && item.status === "O" && (
                <td className="table-bodyBorder" style={{ padding: '8px' }}>
                  <IconButton onClick={(e) => { e.stopPropagation(); onEditRow(item.id); }}>
                    <EditIcon />
                  </IconButton>
                </td>
              )}
              {dataType === "sqhistory" && (
                <td className="table-bodyBorder" style={{ padding: '4px' }}>
                  <IconButton onClick={(e) => { e.stopPropagation(); showEditButton(item); }}>
                    <EditIcon />
                  </IconButton>
                </td>
              )}
            </tr>
          ))
        )}
      </tbody>
      {(dataType === "sqItemhistory" || dataType ==="LedgerDoc") && (
        <tfoot>
          <tr>
            <td colSpan={dataType ==="LedgerDoc" ?"8":"7"} style={{ textAlign: 'right', fontWeight: 'bold' }}>Document Total:</td>
            <td>{data.length > 0 ? data[data.length - 1].Document_Total : ''}</td>
          </tr>
        </tfoot>
      )}
      <Menu
        className='menu_div'
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        dense ="true"
      >
        {['Oppr_Create_Date', 'Due_Date', 'Order_Date'].includes(menuColumn) ? (
          <div style={{ padding: '20px', width: '230px' }}>
            <label>From Date</label>
            <input
              type="date"
              value={dateRange.from || ''}
              onChange={(e) =>
                setDateRange(prev => ({ ...prev, from: e.target.value }))
              }
            />
            <label style={{ marginTop: '10px' }}>To Date</label>
            <input
              type="date"
              value={dateRange.to || ''}
              onChange={(e) =>
                setDateRange(prev => ({ ...prev, to: e.target.value }))
              }
            />
            <button
              className="frmtodate"
              style={{ marginTop: '12px' }}
              onClick={() => {
                if (!dateRange.from || !dateRange.to) {
                  alert('Please select both From and To dates.');
                  return;
                }
                handleMenuItemClick(dateRange);
                handleMenuClose();
              }}
            >
              Apply
            </button>
          </div>
        ) : (
          <div>
            {menuColumn === 'Next_FollowUp' && (
              <>
                <MenuItem disabled>
                  <ListItemText
                    primary="Sort By Date"
                    primaryTypographyProps={{
                      fontWeight: 'bold',
                      fontSize: '13px',
                      color: '#666',
                    }}
                  />
                </MenuItem>
                <MenuItem
                  selected={sortConfig?.column === 'Next_FollowUp' && sortConfig?.direction === 'asc'}
                  onClick={() => {
                    handleSortClick('Next_FollowUp', 'asc');
                    handleMenuClose();
                  }}
                >
                  <ArrowUpwardIcon sx={{ fontSize: '16px', marginRight: '8px', color: '#1976d2' }} />
                  <ListItemText primary="Asc" />
                </MenuItem>
                <MenuItem
                  selected={sortConfig?.column === 'Next_FollowUp' && sortConfig?.direction === 'desc'}
                  onClick={() => {
                    handleSortClick('Next_FollowUp', 'desc');
                    handleMenuClose();
                  }}
                >
                  <ArrowDownwardIcon sx={{ fontSize: '16px', marginRight: '8px', color: '#1976d2' }} />
                  <ListItemText primary="Desc" />
                </MenuItem>
                <Divider />
              </>
            )}
            {menuItems.map((item, index) => (
              <MenuItem key={index} onClick={() => {
                handleMenuItemClick(item);
                handleMenuClose();
              }}>
                <Checkbox checked={selectedFilters[menuColumn]?.includes(item) || false} size="small" />
                <ListItemText primary={`${item} (${getValueCount(item)})`} />
              </MenuItem>
            ))}
          </div>
        )}
      </Menu>
    </table>
  );
};

export default CommonDynamicTable;
